import { isEmpty, validateEmail, validateMobileNumber } from '../../../../utils/generic';

export const assessmentValidator = (application_questions, values) => {
  const cd = {};

  application_questions.forEach((item) => {
    switch (item.render_type) {
      case 'integer':
        if (item.ismandatory) {
          if (!values[item.sequence - 1]) {
            cd[item.sequence - 1] = 'Required';
          } else if (isNaN(values[item.sequence - 1])) {
            cd[item.sequence - 1] = 'Must be Integer';
          } else if (Number(values[item.sequence - 1]) < 0) {
            cd[item.sequence - 1] = 'Must be Positive';
          }
        }

        break;

      case 'float':
        if (item.ismandatory) {
          if (!values[item.sequence - 1]) {
            cd[item.sequence - 1] = 'Required';
          } else if (isNaN(values[item.sequence - 1])) {
            cd[item.sequence - 1] = 'Must be Number';
          } else if (Number(values[item.sequence - 1]) < 0) {
            cd[item.sequence - 1] = 'Must be Positive';
          }
        }

        break;

      case 'email':
        if (item.ismandatory) {
          if (!values[item.sequence - 1]) {
            cd[item.sequence - 1] = 'Required';
          } else if (!validateEmail(values[item.sequence - 1])) {
            cd[item.sequence - 1] = 'Invalid Mail';
          }
        }

        break;

      case 'phone':
        if (item.ismandatory) {
          if (!values[item.sequence - 1]) {
            cd[item.sequence - 1] = 'Required';
          } else if (!validateMobileNumber(values[item.sequence - 1])) {
            cd[item.sequence - 1] = 'Invalid Mobile Number';
          }
        }

        break;

      case 'date_time':

      case 'date':

      case 'time':
        if (item.ismandatory) {
          if (values[item.sequence - 1] === 'Invalid date' || !values[item.sequence - 1]) {
            cd[item.sequence - 1] = 'Required';
          }
        }

        break;

      case 'date_range':

      case 'datetime_range':

      case 'time_range':
        if (item.ismandatory) {
          if (Array.isArray(values[item.sequence - 1]) && (!values[item.sequence - 1].includes('Invalid date') || !values[item.sequence - 1].includes(null))) {
            return;
          } else {
            cd[item.sequence - 1] = [];

            if (values[item.sequence - 1][0] === 'Invalid date' || !values[item.sequence - 1][0] || !values[item.sequence - 1]) {
              cd[item.sequence - 1][0] = 'Required';
            }

            if (values[item.sequence - 1][1] === 'Invalid date' || !values[item.sequence - 1][1] || !values[item.sequence - 1]) {
              cd[item.sequence - 1][1] = 'Required';
            }
          }
        }

        break;

      default:
        if (item.ismandatory && isEmpty(values[item.sequence - 1])) {
          cd[item.sequence - 1] = 'Required';
        }

        break;
    }
  });

  return cd;
};
